export const vivotekDataUploadCorrectValues = {
    dataUploadInterval: 900,
    dataUploadGranularity: 60,
};
